import * as React from 'react';

import { Carousel } from '../../components/Carousel';
import { PhotoFeatureIcons } from '../../components/PhotoFeatureIcons';
import { useApplicationContext } from '../../context/applicationContext';
import { useOfferContext } from '../OfferContext';
import { EPessimizationBackground, IMedia, IPessimization } from '../../types';

export const CarouselContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const offerContext = useOfferContext();
  const {
    media: offerMedia = [],
    photoFeatureIcons,
    isBookedFromDeveloper,
    isExternalTourAvailable,
    moderationInfo,
  } = offerContext;
  const pessimizationRaw = moderationInfo?.photoStub || null;
  const isExternalTourEnabled = !!config.get<boolean>('external_tour_enabled.Enabled');
  const isExternalTourHide = isExternalTourAvailable && !isExternalTourEnabled;
  const featureIcons = (
    <PhotoFeatureIcons isExternalTourHide={isExternalTourHide} photoFeatureIcons={photoFeatureIcons} />
  );

  const pessimization = React.useMemo<IPessimization | undefined>(() => {
    if (!pessimizationRaw?.text) {
      return undefined;
    }

    return {
      background:
        (pessimizationRaw?.background as unknown as EPessimizationBackground) || EPessimizationBackground.Gray,
      text: pessimizationRaw.text,
    };
  }, [pessimizationRaw]);

  const media = React.useMemo(() => {
    return offerMedia.map<IMedia>(({ type, previewUrl, url }) => ({
      previewUrl: getPreviewUrl(previewUrl),
      type: type as unknown as IMedia['type'],
      src: url,
    }));
  }, [offerMedia]);

  return (
    <Carousel
      bookedFromDeveloper={isBookedFromDeveloper}
      slotSliderEnd={featureIcons}
      media={media}
      pessimization={pessimization}
    />
  );
};

const YOUTUBE_LINK_REGEX =
  /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;

/**
 * previewUrl для ютуба приходит в виде ссылки на видео, а не превью
 * Поэтому для корректного отображения для ютуба нужно вырезать previewUrl
 * Далее в компоненте Video для ютуба превью формируется из src
 */
function getPreviewUrl(previewUrl: string) {
  return YOUTUBE_LINK_REGEX.test(previewUrl) ? undefined : previewUrl;
}
